import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { TOMATO_RED } from '@propertypal/shared/src/styles/theme';
import { PINK } from '@propertypal/shared/src/styles/theme/propertynews';
import platform from '@propertypal/shared/src/utils/platform';
import React from 'react';
import { ToastContainer, toast, ToastOptions } from 'react-toastify';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import 'react-toastify/dist/ReactToastify.css';
import { ToastMessage, ToastTitle } from './Toast.styles';

export interface ToastTypes {
  title?: string | undefined;
  message?: string | JSX.Element | undefined;
  type?: 'info' | 'success' | 'warning' | 'error';
  options?: ToastOptions | undefined;
  style?: React.CSSProperties | undefined;
}

const defaultOptions: ToastOptions | undefined = {
  position: 'top-right',
  autoClose: 6000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  closeButton: () => <FontAwesomeIcon icon={faTimes} color="#fff" size={12} />,
};

export const openToast = ({ title, message, type, options, style }: ToastTypes) => {
  const markup = (
    <div data-testid="toast">
      {title && <ToastTitle data-testid="toast-title">{title}</ToastTitle>}
      {message && <ToastMessage data-testid="toast-message">{message}</ToastMessage>}
    </div>
  );

  const styles = {
    style: {
      background: platform.select(TOMATO_RED, PINK),
      color: '#fff',
      borderRadius: '6px',
      fontFamily: 'inherit',
      ...style,
    },
  };

  const opts = {
    ...defaultOptions,
    ...styles,
    ...options,
  };

  if (!type) toast(markup, opts);
  else toast[type](markup, opts);
};

const ToastProvider = () => {
  return <ToastContainer />;
};

export default ToastProvider;
